import { useMutation, useQueryClient } from "@tanstack/react-query";

import { reviewCarbonProgramDraft } from "services";

import { GET_CARBON_PROGRAM_DRAFT, GET_CARBON_PROGRAM_DRAFTS, REVIEW_CARBON_PROGRAM_DRAFT } from "consts";

export const useReviewCarbonProgramDraft = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationKey: [REVIEW_CARBON_PROGRAM_DRAFT],
    mutationFn: reviewCarbonProgramDraft,
    onSuccess: (draft) => {
      queryClient.invalidateQueries({ queryKey: [GET_CARBON_PROGRAM_DRAFTS] });
      queryClient.setQueryData([GET_CARBON_PROGRAM_DRAFT, draft.id], draft);
    },
  });
};
